export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.2">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h54L100 34.1v90.7c0 6.9-6 12.5-12.9 12.5H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <g fill="#6D7577">
        <path d="M18.6 91.6v-2.8h19.7v2.8H30v21.8h-3.3V91.6h-8.1zM38.7 88.8h3.9l6.1 9.6 6.4-9.6h3.7l-8.1 12 8.6 12.6h-4l-6.6-10.2-6.8 10.2h-3.7l8.5-12.6-8-12zM59.4 91.6v-2.8h19.7v2.8h-8.2v21.8h-3.3V91.6h-8.2z"/>
    </g>
    <path fill="${fill? fill : '#A1AFAF'}" d="M66.5 0v34.1H100L66.5 0z"/>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/files/txt.jsx